module.exports = "/images/video-play-btn.svg?8c4be8d260246c0a657f97778790f809";